module.exports = __webpack_public_path__ + "img/chaoguan.60ad6dc2.png";